<template>
	<div>
		<v-toolbar flat dense card>
			<v-btn-toggle v-model="toggleFormat" multiple>
				<v-btn flat value="bold">
					<v-icon>format_bold</v-icon>
				</v-btn>
				<v-btn flat value="italic">
					<v-icon>format_italic</v-icon>
				</v-btn>
				<v-btn flat value="underline">
					<v-icon>format_underlined</v-icon>
				</v-btn>
			</v-btn-toggle>
			<v-spacer></v-spacer>
			<v-btn-toggle>
				<v-btn-toggle v-model="toggleAlignment">
          <v-btn flat value="left">
            <v-icon>format_align_left</v-icon>
          </v-btn>
          <v-btn flat value="center" disabled>
            <v-icon>format_align_center</v-icon>
          </v-btn>
          <v-btn flat value="right" disabled>
            <v-icon>format_align_right</v-icon>
          </v-btn>
        </v-btn-toggle>
			</v-btn-toggle>
			<v-btn-toggle>
				<v-btn flat @click="setHeaderOne()">
					<v-icon>title</v-icon>
				</v-btn>
				<v-btn flat @click="setHeaderTwo()">
					<v-icon>text_fields</v-icon>
				</v-btn>
			</v-btn-toggle>
			<v-spacer></v-spacer>
			<v-btn flat value="clear" @click="removeFormat()">
				<v-icon>format_clear</v-icon>
			</v-btn>
		</v-toolbar>
		<div ref="editor"></div>
	</div>
</template>
<script>
	import Quill from 'quill';

	export default {
		name: 'Editor', 
		props: {
			value: {
				type: String, 
				deafult: ''
			}
		}, 
		data(){
			return {
				editor: null, 
				toggleFormat: [], 
				toggleAlignment: 'left', 
				bolded: false, 
				italicized: false, 
				underlined: false,
				headerOne: false, 
				headerTwo: false
			}
		}, 
		mounted(){
			this.editor = new Quill(this.$refs.editor, {
				modules: {
					toolbar: false
        },
        theme: 'snow',
			});

			this.editor.root.innerHTML = this.value;

			this.editor.on('text-change', () => { this.update() });
		}, 
		methods: {
			update(){
				this.$emit('input', this.editor.getText() ? this.editor.root.innerHTML : '');
			}, 
			removeFormat(){
				let range = this.editor.getSelection();
				if(range){
					if(range.length == 0){
						return;
					} else {
						this.editor.removeFormat(range.index, range.length);
					}
				} 
			}, 
			setHeaderOne(){
				this.headerOne = !this.headerOne;
				let value = this.headerOne ? 'h1' : false;
				this.editor.format('header', value);
			}, 
			setHeaderTwo(){
				this.headerTwo = !this.headerTwo;
				let value = this.headerTwo ? 'h2' : false;
				this.editor.format('header', value);
			}
		}, 
		watch:{
			toggleAlignment(newValue, oldValue){
				if (newValue === oldValue) {return;}
				else {
					this.editor.format('align', null);
					this.editor.format('align', this.toggleAlignment);
				}
			}, 
			toggleFormat(value, oldValue){
				if(value.indexOf('bold') != -1){
					this.editor.format('bold', true);
				} else {
					this.editor.format('bold', null);
				}

				if(value.indexOf('italic') != -1){
					this.editor.format('italic', true);
				} else {
					this.editor.format('italic', null);
				}

				if(value.indexOf('underline') != -1){
					this.editor.format('underline', true);
				} else {
					this.editor.format('underline', null);
				}
			}
		}
	}
</script>